var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTerminal = function SvgTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "terminal_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#terminal_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.92 5.953v12.882l-1.391-.014-.006-12.265h-5.291v1.087a15.7 15.7 0 0 0-.468-.025h-.563c-.12.004-.24.01-.36.018v-1.59c0-.486.395-.882.882-.882h6.412c.435 0 .788.354.788.788l-.002.001Zm-6.694 12.883h3.644V9.378c-.124-.522-1.52-1.12-3.644-1.27-.155-.01-.314-.019-.476-.025h-.546c-.125.005-.248.011-.369.018-2.202.137-3.651.761-3.749 1.296a.226.226 0 0 0-.006.057l.01 9.384h3.745l1.391-.002Zm.588-9.06H9.137v.465h2.677v-.465Zm-2.677 1.726h2.677v.464H9.137v-.464Zm2.677 1.726H9.137v.464h2.677v-.464Zm-2.677 1.725h2.677v.465H9.137v-.465Zm0 1.726h2.677v.464H9.137v-.464Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "terminal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgTerminal as ReactComponent };